import axios from 'axios';

const HTTP_HEADERS_AUTHORIZATION = 'Authorization';
const HTTP_HEADERS_X_ACCESS_TOKEN = 'X-Access-Token';
const HTTP_HEADERS_X_REFRESH_TOKEN = 'X-Refresh-Token';

// API 기본 URL 설정
const API_BASE_URL = import.meta.env.VITE_ADMIN_BACKEND_API_URL || 'http://localhost:8080/api/v1';

// axios 인스턴스 생성 및 설정
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        // API 요청임을 나타내는 커스텀 헤더 추가
        'X-API-Request': 'true'
    },
    timeout: 30000, // 30초로 타임아웃 연장
});

// 요청 인터셉터 설정 - 모든 요청에 JWT 토큰 추가
apiClient.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('ab_at');
        const refreshToken = localStorage.getItem('ab_rt');
        
        // JWT 토큰 설정
        if (accessToken) {
            // Authorization 헤더 설정 - Bearer 접두어 포함
            config.headers[HTTP_HEADERS_AUTHORIZATION] = `Bearer ${accessToken}`;
            config.headers[HTTP_HEADERS_X_ACCESS_TOKEN] = `Bearer ${accessToken}`;
        } else {
            console.warn('액세스 토큰이 없습니다. 인증되지 않은 요청이 전송됩니다.');
        }
        
        // 리프레시 토큰 처리
        if (refreshToken) {
            config.headers[HTTP_HEADERS_X_REFRESH_TOKEN] = `${refreshToken}`;
        }
        
        return config;
    },
    (error) => {
        console.error('요청 인터셉터 오류:', error);
        return Promise.reject(error);
    }
);

// 응답 인터셉터 추가 - 에러 처리 및 토큰 만료 처리
apiClient.interceptors.response.use(
    (response) => {
        // 토큰 갱신 헤더가 있는지 확인
        if (response.headers['x-token-refreshed'] === 'true') {
            const newAccessToken = response.headers[HTTP_HEADERS_AUTHORIZATION]?.replace('Bearer ', '') ||
                                  response.headers[HTTP_HEADERS_X_ACCESS_TOKEN]?.replace('Bearer ', '');
            
            if (newAccessToken) {
                localStorage.setItem('ab_at', newAccessToken);
                console.log('액세스 토큰이 갱신되었습니다.');
            }
            
            // 리프레시 토큰은 응답에 포함된 경우에만 갱신
            const newRefreshToken = response.headers[HTTP_HEADERS_X_REFRESH_TOKEN];
            if (newRefreshToken) {
                localStorage.setItem('ab_rt', newRefreshToken);
                console.log('리프레시 토큰이 갱신되었습니다.');
            }
        }
        return response;
    },
);

export default apiClient;
export { API_BASE_URL };
export { HTTP_HEADERS_AUTHORIZATION };
export { HTTP_HEADERS_X_ACCESS_TOKEN };
export { HTTP_HEADERS_X_REFRESH_TOKEN };